import React from 'react';
import { createFilterOptions, Grid } from '@mui/material';

import { useSettings } from 'app/main/components/hooks';
import { SearchSelectField, SimpleTextField } from 'app/main/components/fields';
import { type DetailsSectionInfoContentProps } from 'app/main/components/page-layouts';

export default function UsersDetailsSectionAddress(props: DetailsSectionInfoContentProps & { type: string }) {
	const { t } = useSettings();

	return (
		<>
			{/* ADDRESS */}
			<Grid size={12}>
				<SimpleTextField
					name={`user_${props.type}_address`}
					label={t('DETAILS_USERS_FIELD_ADDRESS')}
					value={props.model[`user_${props.type}_address`]}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			{/* ADDRESS CITY */}
			<Grid size={{ sm: 6, xs: 12 }}>
				<SimpleTextField
					name={`user_${props.type}_city`}
					label={t('DETAILS_USERS_FIELD_ADDRESS_CITY')}
					value={props.model[`user_${props.type}_city`]}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			{/* ADDRESS ZIP */}
			<Grid size={{ sm: 6, xs: 12 }}>
				<SimpleTextField
					name={`user_${props.type}_zip`}
					label={t('DETAILS_USERS_FIELD_ADDRESS_ZIP')}
					value={props.model[`user_${props.type}_zip`]}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			{/* ADDRESS DISTRICT */}
			<Grid size={{ sm: 6, xs: 12 }}>
				<SearchSelectField
					name={`user_${props.type}_dist_id`}
					label={t('DETAILS_USERS_FIELD_ADDRESS_DISTRICT')}
					systable="districts"
					value={props.model[`user_${props.type}_dist_id`]}
					filters={
						props.model[`user_${props.type}_regi_id`]
							? [
									{
										filt_field: 'dist_regi_id',
										filt_clause: 'equals',
										filt_value: props.model[`user_${props.type}_regi_id`]
									}
								]
							: []
					}
					filterOptions={{
						stringify: option => `${option.dist_iso} ${option.dist_title}`
					}}
					getOptionLabel={option => `${option.dist_iso} - ${option.dist_title}`}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					afterChange={value => {
						if (!value) return;
						props.sendChange(`user_${props.type}_ctry_id`, value.regi_ctry_id);
						props.sendChange(`user_${props.type}_regi_id`, value.dist_regi_id);
					}}
					logProps={props.logProps}
				/>
			</Grid>
			{/* ADDRESS REGION */}
			<Grid size={{ sm: 6, xs: 12 }}>
				<SearchSelectField
					name={`user_${props.type}_regi_id`}
					label={t('DETAILS_USERS_FIELD_ADDRESS_REGION')}
					systable="regions"
					value={props.model[`user_${props.type}_regi_id`]}
					filters={
						props.model[`user_${props.type}_ctry_id`]
							? [
									{
										filt_field: 'regi_ctry_id',
										filt_clause: 'equals',
										filt_value: props.model[`user_${props.type}_ctry_id`]
									}
								]
							: []
					}
					groupBy={option => option.ctry_title}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					afterChange={value => {
						if (!value) return;
						props.sendChange(`user_${props.type}_ctry_id`, value.regi_ctry_id);
					}}
					logProps={props.logProps}
				/>
			</Grid>
			{/* ADDRESS COUNTRY */}
			<Grid size={{ sm: 6, xs: 12 }}>
				<SearchSelectField
					name={`user_${props.type}_ctry_id`}
					label={t('DETAILS_USERS_FIELD_ADDRESS_COUNTRY')}
					systable="countries"
					value={props.model[`user_${props.type}_ctry_id`]}
					filterOptions={{
						stringify: option => `${option.dist_iso} ${option.dist_title}`
					}}
					getOptionLabel={option => `${option.ctry_iso} - ${option.ctry_title}`}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			{/* ADDRESS ZONE */}
			<Grid size={{ sm: 6, xs: 12 }}>
				<SearchSelectField
					name={`user_${props.type}_zone_id`}
					label={t('DETAILS_USERS_FIELD_ADDRESS_ZONE')}
					systable="zones"
					value={props.model[`user_${props.type}_zone_id`]}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
		</>
	);
}
